import { useState, useCallback, useRef } from 'react';
import isPointInPolygon from '../utils/mouseTracking/isPointInPolygon';
import getCurrentMenu from '../utils/mouseTracking/getCurrentMenu';
import throttle from '../../../utils/throttle';
const useMenuPickerMouseTracking = ({
  submenuRef,
  submenuTriggerRef
}) => {
  const [isSubmenuOpen, setIsSubmenuOpen] = useState(false);
  const isMouseMovingTowardsSubmenu = useRef(false);
  const onMouseEnter = useCallback(() => {
    setIsSubmenuOpen(true);
  }, []);
  const onMouseMove = throttle(evt => {
    if (!submenuRef.current || !submenuTriggerRef.current) {
      isMouseMovingTowardsSubmenu.current = false;
      return;
    }
    const submenuRect = submenuRef.current.getBoundingClientRect();
    const submenuTriggerRect = submenuTriggerRef.current.getBoundingClientRect();
    const currentMenu = getCurrentMenu({
      currentMousePosition: {
        x: evt.clientX,
        y: evt.clientY
      },
      submenuRect,
      submenuTriggerRect
    });
    if (evt.movementX < 0 && currentMenu === submenuTriggerRect || evt.movementX > 0 && currentMenu === submenuRect) {
      isMouseMovingTowardsSubmenu.current = true;
      return;
    }
    isMouseMovingTowardsSubmenu.current = false;
  }, 30);
  const onMouseLeave = useCallback(evt => {
    if (!submenuRef.current || !submenuTriggerRef.current) {
      setIsSubmenuOpen(false);
      isMouseMovingTowardsSubmenu.current = false;
      return;
    }
    const submenuRect = submenuRef.current.getBoundingClientRect();
    const submenuTriggerRect = submenuTriggerRef.current.getBoundingClientRect();
    const acceptableBoundary = [{
      x: submenuRect.left,
      y: submenuRect.top
    }, {
      x: submenuTriggerRect.right,
      y: submenuTriggerRect.top
    }, {
      x: submenuTriggerRect.right,
      y: submenuTriggerRect.bottom
    }, {
      x: submenuRect.left,
      y: submenuRect.bottom
    }];
    const isInBoundary = isPointInPolygon({
      point: {
        x: evt.clientX,
        y: evt.clientY
      },
      polygon: acceptableBoundary
    });
    if (!isMouseMovingTowardsSubmenu.current || !isInBoundary) {
      setIsSubmenuOpen(false);
      isMouseMovingTowardsSubmenu.current = false;
    }
  }, [isMouseMovingTowardsSubmenu, submenuRef, submenuTriggerRef]);
  return {
    isSubmenuOpen,
    setIsSubmenuOpen,
    onMouseEnter,
    onMouseMove,
    onMouseLeave,
    isMouseMovingTowardsSubmenu
  };
};
export default useMenuPickerMouseTracking;